<template>
  <div class="qiYun">
    <el-descriptions :title="qiYunData.fullName" :column="2" border>
      <el-descriptions-item
        label="在职时间"
        label-class-name="my-label"
        content-class-name="my-content"
      >
        {{ qiYunData.duration }}
      </el-descriptions-item>

      <el-descriptions-item
        label="所在岗位"
        label-class-name="my-label"
        content-class-name="my-content"
      >
        {{ qiYunData.post }}
      </el-descriptions-item>

      <el-descriptions-item
        label="工作内容"
        label-class-name="my-label"
        content-class-name="my-content"
      >
        {{ qiYunData.workAbout }}
      </el-descriptions-item>
    </el-descriptions>

    <div class="qiYun-title">项目经历</div>
    <div class="qiYun-project">
      <el-carousel
        indicator-position="outside"
        :interval="10000"
        :autoplay="false"
        arrow="always"
      >
        <el-carousel-item v-for="(chunk, index) in resProjectArr" :key="index">
          <div
            class="qiYun-project-public"
            v-for="item in chunk"
            :key="item.id"
          >
            <div class="img">
              <el-image
                class="imgComp"
                :src="`/img/qiYunProject/${item.name}.png` | imgFormat"
                :preview-src-list="
                  [`/img/qiYunProject/${item.name}.png`] | imgFormat
                "
              >
                <div slot="placeholder" class="image-slot">
                  <img
                    style="width: 100%"
                    src="https://pic.imgdb.cn/item/65abdd55871b83018af558ee.gif"
                    alt=""
                  />
                </div>

                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>

            <div class="info" @click="showProjectDetailDialog(item.name, item)">
              <el-tooltip
                class="item"
                effect="dark"
                :content="`点击查看${item.name}详情`"
                placement="top"
              >
                <span class="info-name">{{ item.name }}</span>
                <span class="info-time">{{ item.time }}</span>
              </el-tooltip>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <detailDialog ref="detailDialog" />
  </div>
</template>

<script>
import {
  companyList,
  companyListEncryption,
  qiYun,
  qiYunEncryption,
} from "@/api/apifoxInterface";
import makeNumArr from "@/utils/makeNumArr";
import detailDialog from "@/views/homePage/projectBoxUnit/detailDialog.vue";
export default {
  name: "qiYun",
  components: { detailDialog },
  props: {},
  computed: {
    permission() {
      return this.$store.state.auth.permission;
    },
  },
  watch: {
    permission(newVal) {
      if (newVal.id === 3) {
        this.getQiYunData();
      }
    },
  },
  data() {
    return {
      qiYunData: {},
      resProjectArr: [],

      helpQiYunData: require("@/lib/json/apifox/qiYun.json"),
      helpQiYunDataEncryption: require("@/lib/json/apifox/qiYunE.json"),
    };
  },
  methods: {
    showProjectDetailDialog(title, data) {
      if (this.permission.id !== 3) {
        this.$message.warning("抱歉，您没有权限查看");
        return;
      }
      this.$refs.detailDialog.showDialog({ title, data, type: "qiYunProject" });
    },

    async getQiYunData() {
      const getCompanyData = async () => {
        const res = await (this.permission.id === 3
          ? qiYun()
          : qiYunEncryption());
        if (res.data.code === 200) {
          return res.data.data;
        } else if (res.data.code === 504) {
          return this.permission.id === 3
            ? this.helpQiYunData.data
            : this.helpQiYunDataEncryption.data;
        }
        throw new Error(`Failed with code: ${res.data.code}`);
      };
      try {
        this.qiYunData = await getCompanyData();
        this.resProjectArr =
          this.qiYunData?.projectList && this.qiYunData.projectList.length > 0
            ? makeNumArr(this.qiYunData.projectList, 6)
            : [];
      } catch (error) {
        console.error("An error occurred:", error.message);
      }
    },
  },
  created() {
    this.getQiYunData();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.qiYun {
  position: relative;

  &-title {
    color: #303133;
    font-size: 16px;
    font-weight: 700;
    margin: 20px 0 0;
    text-align: center;
  }

  &-project {
    width: 100%;
    height: calc(100vh - 300px);
    margin-top: 10px;

    &-public {
      width: calc(33% - 40px);
      height: calc(50% - 2px - 40px);
      float: left;
      cursor: pointer;
      padding: 20px;

      .img {
        width: 100%;
        height: calc(100% - 48px);
        text-align: center;

        .imgComp {
          width: 320px !important;
          height: 100% !important;
          /*transition: all 0.6s;*/
          object-fit: contain;
        }
      }

      .info {
        height: 48px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        text-align: center;

        &-name {
          font-size: 14px;
          font-weight: 600;
          margin: 16px 0 8px 0;
        }

        &-time {
          color: #333;
          font-size: 14px;
        }

        span {
          width: 100%;
        }
      }

      .info:hover {
        color: #587fdc !important;
      }
    }

    &-public:hover {
      transform: scale(1.2);
    }
  }
}

::v-deep .my-label {
  width: 150px !important;
}

::v-deep .my-content {
}

.el-carousel--horizontal {
  width: 100% !important;
  height: calc(100vh - 300px) !important;
}

::v-deep .el-carousel__container {
  height: calc(100vh - 330px) !important;
}

::v-deep .el-carousel__item {
}
</style>
